﻿import { PasswordEditor, PrefixedContext, initFormType } from "@serenity-is/corelib";

export interface ElevateForm {
    Password: PasswordEditor;
}

export class ElevateForm extends PrefixedContext {
    static readonly formKey = 'Membership.Elevate';
    private static init: boolean;

    constructor(prefix: string) {
        super(prefix);

        if (!ElevateForm.init)  {
            ElevateForm.init = true;

            var w0 = PasswordEditor;

            initFormType(ElevateForm, [
                'Password', w0
            ]);
        }
    }
}